const calculateTotalAccordingToMeasure = (Data, responseKey, measure) => {
  let total = 0;

  switch (measure) {
    case "calculatedField":
    case "COUNT":
    case "SUM":
      Data.forEach((row) => {
        total += Number(row[responseKey]);
      });
      return total;

    case "MIN":
      total = Number(Data[0][responseKey]);
      Data.forEach((row) => {
        const currentValue = Number(row[responseKey]);
        if (currentValue < total) {
          total = currentValue;
        }
      });
      return total;

    case "MAX":
      total = Number(Data[0][responseKey]);
      Data.forEach((row) => {
        const currentValue = Number(row[responseKey]);
        if (currentValue > total) {
          total = currentValue;
        }
      });
      return total;
    case "DISTINCT":
    case "AVG":
      return null;

    default:
      // Default behavior can be the same as SUM
      Data.forEach((row) => {
        total += Number(row[responseKey]);
      });
      return total;
  }
};

const calculateNumber = (
  Data,
  valueKeys,
  rawGroupByKeys,
  externalTotalRequired,
  totalData,
  isSuccess
) => {
  console.log(
    Data,
    valueKeys,
    rawGroupByKeys,
    externalTotalRequired,
    totalData,
    isSuccess
  );

  if (valueKeys.length > 0) {
    const responseKey = valueKeys[0].responseKey;

    if (rawGroupByKeys && rawGroupByKeys.length !== 0) {
      if (externalTotalRequired && isSuccess) {
        console.log(totalData, responseKey, totalData[responseKey]);
        return Number(totalData[0][responseKey]);
      } else {
        const measure = valueKeys[0]?.measure?.value;
        console.log(measure);

        return calculateTotalAccordingToMeasure(Data, responseKey, measure);
      }
    } else {
      const result = Number(Data[0]?.[responseKey]);
      console.log(result);
      return result;
    }
  } else {
    return null;
  }
};

export { calculateNumber };
